export default {
  state: {
    visibility: false
  },
  mutations: {
    INIT_SET_OFFLINE_HOUR_OF_LIVE_VIDEO_DIALOG(state) {
      state.visibility = true
    },
    RESET_SET_OFFLINE_HOUR_OF_LIVE_VIDEO_DIALOG(state) {
      state.visibility = false
    }
  }
}
